/*
 * @Author: 张天昊
 * @Date: 2024-05-21 11:55:26
 * @LastEditTime: 2024-05-21 11:59:06
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/utils/px2rem.js
 */
export function px2rem(px) {
  const scale = document.documentElement.clientWidth / 375;
  const baseSize = 37.5 * scale;
  // 1rem = 37.5px
  return (px / baseSize).toFixed(5) + 'rem';
}
